module.exports = __webpack_public_path__ + "media/src/assets/Images/LogoFascioliLandingPage-9ef5c394f0d840b697e0eab5872b2def.png";